export default function PrivacyPolicyPage() {
  return (
    <section className="py-16 px-6 max-w-4xl mx-auto">
      <h1 className="text-3xl font-bold text-[#055862] mb-6">Privacy Policy</h1>
      <p className="text-gray-700 mb-4">
        iDisKover values your privacy. This policy outlines how we collect, use, and protect your information.
      </p>
      <ul className="list-disc pl-6 space-y-2 text-gray-700 text-base">
        <li>We collect user data only to improve platform functionality and user experience.</li>
        <li>We do not share or sell your data to any third parties.</li>
        <li>All data is stored securely and encrypted in compliance with global standards.</li>
        <li>Users can request deletion or review of their data at any time.</li>
      </ul>
    </section>
  );
}
